export default "__VITE_ASSET__lna6YeIp__"